import * as api from "../../api/index";
import * as endpoints from "../../api/endpoints";
import * as types from "../../mutation-types";

const actions = {
  getPersons({ commit }, payload) {
    return api.fetch(endpoints.PERSONS, payload, commit, (response) => {
      commit(types.SET_PERSONS, response.data.data);
      commit("common/" + types.SET_PAGINATION, response.data.meta, { root: true });
    });
  },
  createPerson({ commit }, payload) {
    return api.post(endpoints.PERSONS, payload, commit);
  },
  updatePerson({ commit }, payload) {
    return api.put(endpoints.PERSONS + "/" + payload.uuid, payload, commit);
  },
  deletePerson({ commit }, payload) {
    return api.remove(endpoints.PERSONS + "/" + payload.uuid, payload, commit);
  },
  getEmployeeGroups({ commit }, payload) {
    return api.fetch(endpoints.EMPLOYEE_GROUPS, payload, commit, (response) => {});
  },
};

export default actions;
